import React, { useEffect, useState } from "react";

import "./Documents.scss";

import { AbsCheckBox, AttachmentsUpload, Button } from "abs-ui-components";

const BrowseDocumentFile = ({
	handleUploadClick,
	documentHeader,
	toggleCloseModal,
	selectedFiles,
	setSelectedFiles,
	isDocumentsModalOpen,
}) => {
	const [dragged, setDragged] = useState(null);
	const [checkedItems, setCheckedItems] = useState({});
	const [childList, setChildList] = useState("");

	const handleCheckboxChange = (id, info) => {
		setCheckedItems((prevState) => ({
			...prevState,
			[id]: !prevState[info.reportMstId],
		}));
	};

	useEffect(() => {
		const keysArray = Object.keys(checkedItems).filter(
			(key) => checkedItems[key]
		);
		setChildList(keysArray);
	}, [checkedItems]);

	useEffect(() => {
		if (!isDocumentsModalOpen) {
			setSelectedFiles([]);
		}
	}, [isDocumentsModalOpen, setSelectedFiles]);

	const onDrag = (e) => {
		e.preventDefault();
		if (e.type === "dragover") {
			setDragged(true);
		}
		setDragged((prev) => {
			return prev;
		});
	};

	const onDrop = (e) => {
		e.preventDefault();
		if (e.type === "drop") {
			setDragged(false);
		}
		setDragged((prev) => {
			return prev;
		});
	};

	const handleLocalFilesSelected = (files) => {
		const newFiles = [...selectedFiles];
		files.forEach((selectedFile) => {
			newFiles.push(selectedFile.file);
		});
		setSelectedFiles(newFiles);
	};

	const handleLocalUploadClick = (childList) => {
		handleUploadClick(childList);
		toggleCloseModal();
	};

	const handleRemoveFile = (index) => {
		const newFiles = selectedFiles.filter((_, i) => i !== index);
		setSelectedFiles(newFiles);
	};

	return (
		<div className="p-4 document-file-main-con">
			<div className="mb-3 drag-drop-con">
				<div
					onDragOver={(e) => onDrag(e)}
					className={dragged ? "drag-drop-cls" : null}
					onDrop={(e) => onDrop(e)}
				>
					<AttachmentsUpload
						onFilesSelected={handleLocalFilesSelected}
						supportedFormat=" "
						supportedFileTypes="zip, csv, png, jpg, jpeg, eml, tiff, bmp, txt, ppt, pptx, xls, xlsx, rtf, dwg, gif, pdf"
					/>
				</div>
			</div>

			{selectedFiles.length > 0 && (
				<div className="mb-3 pointer-event">
					<div className="selected-files">
						{selectedFiles.map((file, index) => (
							<div
								key={`cii-part-${index}`}
								className="file-item"
							>
								<span>{file.name}</span>
								<button
									className="remove-btn"
									onClick={() => handleRemoveFile(index)}
								>
									✖
								</button>
							</div>
						))}
					</div>
				</div>
			)}

			<div className="document-checkbox-container row">
				{documentHeader?.map((info) => (
					<div key={info.reportid} className="col-md-4">
						<AbsCheckBox
							slim={true}
							id={info.reportid}
							label={info.reportid}
							checked={checkedItems[info.reportMstId] || false}
							handleChange={() =>
								handleCheckboxChange(info.reportMstId, info)
							}
						/>
					</div>
				))}
			</div>

			<div className="center-content">
				<Button
					disabled={selectedFiles?.length == 0}
					onClick={() =>
						handleLocalUploadClick(JSON.stringify(childList))
					}
				>
					Upload Documents
				</Button>
			</div>
		</div>
	);
};

export default BrowseDocumentFile;
